import React, { createContext, useContext } from 'react'
import { useUsersReducer } from '../hooks/users-reducer.hook'

const UsersContext = createContext()

export const UsersContextProvider = ({ children }) => {
  const reducer = useUsersReducer()
  return <UsersContext.Provider value={reducer}>{children}</UsersContext.Provider>
}

export const useUsersContext = () => useContext(UsersContext)
